const authModule = {
  namespaced: true,
  state: {
    isAuthentication: false,
    token: "",
    toggleCalculator: false,
  },
  mutations: {
    onStart(state) {
      let token = localStorage.getItem("token");
      if (token) {
        state.isAuthentication = true;
        state.token = token;
      } else {
        state.isAuthentication = false;
        state.token = "";
      }
    },
    login(state, token) {
      if (token) {
        state.isAuthentication = true;
        state.token = token;
        localStorage.setItem("token", token);
      } else {
        state.isAuthentication = false;
        state.token = "";
        localStorage.removeItem("token");
      }
    },
    logout(state) {
      state.isAuthentication = false;
      state.token = "";
      localStorage.removeItem("token");
    },
  },
  actions: {},
  modules: {},
};
export default authModule;
